import { useMemo } from 'react';
import {
  AnalyticsMetadataType,
  AnalyticsMetaDataValue,
  useAnalyticsMetaDataQuery
} from 'graphql/types';

export const useGetAnalyticsMetaData = (
  metaDataType: AnalyticsMetadataType
): {
  data: AnalyticsMetaDataValue[];
  loading: boolean;
} => {
  const { loading, data } = useAnalyticsMetaDataQuery({
    variables: {
      input: { type: metaDataType }
    }
  });

  const oefLabels: AnalyticsMetaDataValue[] = useMemo(() => {
    return ((data && data.analyticsMetadata?.metadata) || []).map((x) => x);
  }, [data]);
  return useMemo(
    () => ({
      data: oefLabels,
      loading
    }),
    [loading, oefLabels]
  );
};
